import Vue from 'vue'
import Alert from './Alert'

const alert = (text,title="提示",confirmSure=()=>{}) => {
  const Constructor = Vue.extend(Alert) //创建一个alert子实例

  let instance = new Constructor({
    el: document.createElement('div'), //将alert实例挂载到创建的div上
    data() {
      return {
        text:text,
        title:title
      }
    },
    methods: {
      confirmSure: confirmSure //点击关闭的时候触发的回调函数
    }
  })
  instance.vm = instance.$mount()
  document.getElementById("etoak").appendChild(instance.vm.$el)
  instance.vm.visible = true
  instance.dom = instance.vm.$el
  return instance.vm
}

export default alert
